var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "root",
    staticClass: "slider"
  }, [_vm._l(_vm.image, function (img, i) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.activeIndex === i,
        expression: "activeIndex === i"
      }],
      key: i,
      staticClass: "slider__photo-wrapper"
    }, [_c('img', _vm._b({
      ref: "photo",
      refInFor: true,
      staticClass: "slider__photo"
    }, 'img', i === 0 ? {
      src: img.thumbnail.x1,
      srcset: ((img.thumbnail.x2) + " 2x"),
      alt: _vm.name
    } : {
      'data-src': img.thumbnail.x1,
      'data-srcset': img.thumbnail.x2,
      'alt': _vm.name
    }, false))])];
  }), _vm._v(" "), _vm.image.length > 1 ? _c('div', {
    staticClass: "slider__dot-wrapper"
  }, [_c('DotSlider', {
    staticClass: "slider__dots",
    attrs: {
      "current": _vm.activeIndex,
      "count": _vm.image.length
    }
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }